var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["interval", { "with-prices": _vm.withPrices }] }, [
    _c(
      "div",
      { staticClass: "enable-section section" },
      [
        _c("q-toggle", {
          model: {
            value: _vm.localInterval.isEnabled,
            callback: function($$v) {
              _vm.$set(_vm.localInterval, "isEnabled", $$v)
            },
            expression: "localInterval.isEnabled"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "interval-section section" }, [
      _c("div", { staticClass: "subtitle" }, [
        _vm._v("\n      Интервал*\n    ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "interval-inputs" },
        [
          _c("q-input", {
            staticClass: "input text-center small",
            attrs: {
              square: "",
              required: "",
              outlined: "",
              dense: "",
              "hide-bottom-space": "",
              "no-error-icon": "",
              mask: "time",
              rules: [_vm.required, _vm.time],
              "lazy-rules": _vm.lazyRules
            },
            model: {
              value: _vm.localInterval.from,
              callback: function($$v) {
                _vm.$set(_vm.localInterval, "from", $$v)
              },
              expression: "localInterval.from"
            }
          }),
          _vm._v(" "),
          _c("q-input", {
            staticClass: "input text-center small",
            attrs: {
              square: "",
              required: "",
              outlined: "",
              dense: "",
              "hide-bottom-space": "",
              "no-error-icon": "",
              mask: "time",
              rules: [_vm.required, _vm.time],
              "lazy-rules": _vm.lazyRules
            },
            model: {
              value: _vm.localInterval.to,
              callback: function($$v) {
                _vm.$set(_vm.localInterval, "to", $$v)
              },
              expression: "localInterval.to"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "days-section section" }, [
      _c("div", { staticClass: "subtitle" }, [
        _vm._v("\n      Дни недели и лимит заказа\n    ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "days" },
        _vm._l(_vm.localInterval.days, function(day, index) {
          return _c(
            "div",
            { key: index, staticClass: "day" },
            [
              _c("div", { staticClass: "label" }, [
                _vm._v("\n          " + _vm._s(day.label) + "\n        ")
              ]),
              _vm._v(" "),
              _c("q-toggle", {
                staticClass: "radio",
                attrs: { dense: "" },
                model: {
                  value: day.isEnabled,
                  callback: function($$v) {
                    _vm.$set(day, "isEnabled", $$v)
                  },
                  expression: "day.isEnabled"
                }
              }),
              _vm._v(" "),
              _c("q-input", {
                staticClass: "input text-center small",
                attrs: {
                  square: "",
                  outlined: "",
                  dense: "",
                  "hide-bottom-space": "",
                  "lazy-rules": _vm.lazyRules,
                  mask: "###",
                  "no-error-icon": ""
                },
                model: {
                  value: day.limit,
                  callback: function($$v) {
                    _vm.$set(day, "limit", $$v)
                  },
                  expression: "day.limit"
                }
              })
            ],
            1
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "block-section section" },
      [
        _c("div", { staticClass: "subtitle" }, [
          _vm._v("\n      Блокировка за (часов)\n    ")
        ]),
        _vm._v(" "),
        _c("q-input", {
          staticClass: "input text-center small",
          attrs: {
            square: "",
            outlined: "",
            dense: "",
            "hide-bottom-space": "",
            mask: "##"
          },
          model: {
            value: _vm.localInterval.blockInterval,
            callback: function($$v) {
              _vm.$set(_vm.localInterval, "blockInterval", $$v)
            },
            expression: "localInterval.blockInterval"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm.withPrices
      ? _c(
          "div",
          { staticClass: "section" },
          [
            _c("div", { staticClass: "subtitle" }, [
              _vm._v("\n      Сумма заказа от\n    ")
            ]),
            _vm._v(" "),
            _c("q-input", {
              staticClass: "input text-center small",
              attrs: {
                square: "",
                outlined: "",
                dense: "",
                "hide-bottom-space": "",
                mask: "##########",
                "lazy-rules": "ondemand"
              },
              model: {
                value: _vm.localInterval.orderCostFrom,
                callback: function($$v) {
                  _vm.$set(_vm.localInterval, "orderCostFrom", $$v)
                },
                expression: "localInterval.orderCostFrom"
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.withPrices
      ? _c(
          "div",
          { staticClass: "section" },
          [
            _c("div", { staticClass: "subtitle" }, [
              _vm._v("\n      Сумма заказа до\n    ")
            ]),
            _vm._v(" "),
            _c("q-input", {
              staticClass: "input text-center small",
              attrs: {
                square: "",
                outlined: "",
                dense: "",
                "hide-bottom-space": "",
                mask: "##########",
                "lazy-rules": "ondemand"
              },
              model: {
                value: _vm.localInterval.orderCostTo,
                callback: function($$v) {
                  _vm.$set(_vm.localInterval, "orderCostTo", $$v)
                },
                expression: "localInterval.orderCostTo"
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.withPrices
      ? _c(
          "div",
          { staticClass: "section" },
          [
            _c("div", { staticClass: "subtitle" }, [
              _vm._v("\n      Стоимость доставки\n    ")
            ]),
            _vm._v(" "),
            _c("q-input", {
              staticClass: "input text-center small",
              attrs: {
                square: "",
                outlined: "",
                dense: "",
                "hide-bottom-space": "",
                "lazy-rules": "ondemand",
                mask: "#########"
              },
              model: {
                value: _vm.localInterval.deliveryCost,
                callback: function($$v) {
                  _vm.$set(_vm.localInterval, "deliveryCost", $$v)
                },
                expression: "localInterval.deliveryCost"
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.removeBtn
      ? _c("div", { staticClass: "delete-section section" }, [
          _c("div", {
            staticClass: "icon",
            domProps: { innerHTML: _vm._s(_vm.DeleteIcon) },
            on: { click: _vm.remove }
          })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }